export interface UpgradeUnlockProps {
  tabLabel: string;
  requiredTier: "professional" | "enterprise";
}

/**
 * Tier-locked tab placeholder. Per MER-52 mockup: Growth tier sees
 * an upgrade prompt where Professional / Enterprise tabs would
 * render. DWS is Professional so this is not exercised at go-live;
 * Best Disposal onboarding (Growth) is the first customer to hit it.
 */
export default function UpgradeUnlock(props: UpgradeUnlockProps) {
  return (
    <section
      role="region"
      aria-label={`${props.tabLabel} tab is locked (requires ${props.requiredTier} tier)`}
      style={{
        display: "grid",
        placeItems: "center",
        padding: 48,
        background: "var(--bg-card)",
        border: "1px dashed var(--border-subtle)",
        borderRadius: 14,
        textAlign: "center",
      }}
    >
      <div>
        <div style={{ fontSize: 12, color: "var(--text-muted)", marginBottom: 8 }}>
          {props.requiredTier.toUpperCase()} TIER
        </div>
        <h2 style={{ fontSize: 22, marginBottom: 8 }}>Unlock {props.tabLabel}</h2>
        <p style={{ color: "var(--text-muted)", maxWidth: 420 }}>
          This tab is available on the {props.requiredTier} plan. Contact your Meridian account
          manager to upgrade.
        </p>
      </div>
    </section>
  );
}
